import { FC, HTMLAttributes, JSX } from 'react';
import { BackgroundStyle, PageBackground } from './PageBackground';
import { useHslBuilder } from './useHsl';
import { twMerge } from 'tailwind-merge';

interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  customHeader?: JSX.Element;
  lockHeader?: boolean;
  backgroundStyle?: BackgroundStyle;
  fullWidth?: boolean;
}

export const PageContainer: FC<PageContainerProps> = ({ customHeader, lockHeader, backgroundStyle, children }) => {
  const hslBuilder = useHslBuilder();

  return (
    <div className={twMerge(`h-full flex flex-col relative`, lockHeader ? 'overflow-hidden' : 'overflow-auto')}>
      {customHeader}
      <PageBackground backgroundStyle={backgroundStyle} fixPosition/>
      <div className="w-full h-full fixed -z-20" style={{ background: hslBuilder(1) }}></div>
      {lockHeader ? <div className="flex-1 overflow-auto relative">{children}</div> : children}
    </div>
  );
};
